import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ChangeLocale,
  getAvailableLanguages,
  getCurrentLocale,
  getDefaultLanguageCode,
  Go
} from '@ui/legacy-lib';
import { ThemeService } from '@ui/legacy-lib';
import { filter, take } from 'rxjs/operators';
import { ModalService } from '@ui/legacy-lib';
import { OfflineSelfRegistrationModalComponent } from 'landlord/screens/landings/components/offline-self-registration/components/offline-self-registration-modal/offline-self-registration-modal.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AvailableLanguageCodesEnum, Language } from '@ui/shared/models';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LangPickerComponent } from '@ui/legacy-lib';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@ui/legacy-lib';
import { FormsModule } from '@angular/forms';
import { offlineSelfRegistrationFeature } from 'landlord/main/+state/offline-self-registration/offline-self-registration.reducers';

@UntilDestroy()
@Component({
  selector: 'app-offline-self-registration-intro',
  templateUrl: './offline-self-registration-intro.component.html',
  styleUrls: ['./offline-self-registration-intro.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LangPickerComponent, TranslateModule, ButtonComponent, FormsModule]
})
export class OfflineSelfRegistrationIntroComponent implements OnInit {
  public dataPrivacyUrl: SafeResourceUrl;
  public hasUrl: boolean;

  public availableLanguages: Language[];
  public defaultLanguageCode: AvailableLanguageCodesEnum;
  public currentLanguageCode: AvailableLanguageCodesEnum;
  private store = inject(Store);
  private themeService = inject(ThemeService);
  private modalService = inject(ModalService);
  private sanitizer = inject(DomSanitizer);

  ngOnInit() {
    this.store
      .select(getAvailableLanguages)
      .pipe(untilDestroyed(this))
      .subscribe(
        availableLanguages => (this.availableLanguages = availableLanguages)
      );

    this.store
      .select(getCurrentLocale)
      .pipe(untilDestroyed(this))
      .subscribe(currentLocale => {
        this.currentLanguageCode = currentLocale;
      });

    this.store
      .select(getDefaultLanguageCode)
      .pipe(untilDestroyed(this))
      .subscribe(
        defaultLanguageCode => (this.defaultLanguageCode = defaultLanguageCode)
      );

    this.store
      .select(offlineSelfRegistrationFeature.selectSelfRegistrationConfig)
      .pipe(
        filter(config => !!config),
        take(1)
      )
      .subscribe(config => {
        this.dataPrivacyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          config.dataPrivacyUrl
        );

        this.hasUrl = !!config.dataPrivacyUrl;
      });
  }

  public get logo(): string {
    return (
      this.themeService?.getActiveTheme?.logo?.url ||
      '/assets/images/logos/logo-immomio-main.svg'
    );
  }

  public openLink() {
    this.modalService.open(OfflineSelfRegistrationModalComponent, {
      data: { url: this.dataPrivacyUrl }
    });
  }

  public onLanguageChange(languageCode: AvailableLanguageCodesEnum) {
    this.store.dispatch(new ChangeLocale(languageCode));
  }

  public goToWizard() {
    this.store.dispatch(
      new Go({
        path: ['selfRegistration/wizard'],
        extras: { queryParamsHandling: 'preserve' }
      })
    );
  }
}
